export const inviteToJoinActionTypes = {
    INVITE_TO_JOIN_TOGGLE_VISIBLE_POPUP: 'INVITE_TO_JOIN_TOGGLE_VISIBLE_POPUP',
    INVITE_TO_JOIN_INVITE_ALL_REQUEST: 'INVITE_TO_JOIN_INVITE_ALL_REQUEST',
    INVITE_TO_JOIN_INVITE_ALL_SUCCESS: 'INVITE_TO_JOIN_INVITE_ALL_SUCCESS',
    INVITE_TO_JOIN_INVITE_ALL_FAILURE: 'INVITE_TO_JOIN_INVITE_ALL_FAILURE'
};
